<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="logs">
    <v-card>
      <v-container class="logs-container">
        <v-data-table
          :headers="headers"
          :items="logs"
          :pagination.sync="pagination"
        >
          <template slot="items" slot-scope="props">
            <tr v-bind:class="{'log-warning': props.item.warning}">
              <td class="text-xs-center px-0">{{new Date(props.item.timestamp).toLocaleString("en-GB", {timeZone: 'Europe/Kiev'})}}</td>
              <td class="text-xs-center px-0">{{props.item.lang}}</td>
              <td class="text-xs-center px-0">{{props.item.taskNumber}}</td>
              <td class="text-xs-left px-0">{{getEvent(props.item)}}</td>
              <td class="text-xs-left px-0">{{props.item.input}}</td>
            </tr>
          </template>
        </v-data-table>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import Vue from "vue";
import api from "@/api";

export default Vue.extend({
  name: "logs",

  data() {
    return {
      headers: [
        {value: "timestamp", text: "Date", align: "center", sortable: false, width: "10%"},
        {value: "lang", text: "Lang", align: "center", sortable: false},
        {value: "taskNumber", text: "Task", align: "center", sortable: false},
        {value: "event", text: "Event", align: "center", sortable: false},
        {value: "input", text: "Code", align: "center", sortable: false, width: "70%"},
      ],
      pagination: {
        descending: false,
        sortBy: "timestamp",
        rowsPerPage: -1
      },
      logs: []
    };
  },

  async mounted() {
    const queryParams = new URLSearchParams(window.location.search);
    const sessionId = queryParams.get("sessionId") || "";

    if (sessionId) {
      const { data } = await api.get("programmingLogs", {
        params: {
          sessionId
        }
      });

      this.logs = data.logs;
    }
  },

  methods: {
    getEvent(log) {
      if (log.isManual) {
        return 'manualInput';
      }

      if (!log.event || log.event === 'input') {
        return 'autoInput';
      }

      return log.event;
    }
  }
});
</script>

<style>
  .logs-container {
    max-width: 100%;
  }

  .log-warning {
    background-color: #fafad2;
  }
</style>
